Hello {{user?.user_name}}
<div *ngIf="agents">
  Das sind deine Büros:
  <div *ngFor="let oa of agents?._embedded?.officeAllocations">
    {{oa._embedded.office.name}} | {{oa._embedded.employee.firstName}} {{oa._embedded.employee.lastName}}
  </div>
</div>
<hr>
<router-outlet *ngIf="user"></router-outlet>
